export default {"src":"/_next/static/media/card-3.f9691ac2.svg","height":568,"width":568,"blurWidth":0,"blurHeight":0};